import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import {OrderStatusPageContext} from "@MasterBluePrint/Overrides/Pages/OrderStatusPage";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import themeColors, { themeFontSizes, themeFontWeights, themeIndentSizes } from "@MasterBluePrint/Styles/variables";
import React, { FC, useContext } from "react";
import { css } from "styled-components";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { connect } from "react-redux";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";

export interface OrderDetailsStatusStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    status?: TypographyProps;
}
const mapStateToProps = (state: ApplicationState) => ({
    orderData: state.pages.orderStatus.order,
});
type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export const statusStyles: OrderDetailsStatusStyles = {
    wrapper: {
        css: css`
            padding-bottom: 0.625rem;
            font-size: ${themeFontSizes.size18};
            font-family: 'Lato',sans-serif;
            letter-spacing: 0;
            line-height: 1.4375rem;
        `,
    },
    titleText: {
        variant: "h3",
        css: css`
            @media print {
                font-size: ${themeFontSizes.size18};
            }
            margin-bottom: 0.3125rem;
            margin-right: 0.3125rem;
            color: ${themeColors.colorPrimary};
            font-family: 'Roboto', sans-serif;
            font-size: ${themeFontSizes.size18};
            font-weight: ${themeFontWeights.fontWeightForBold};
            display: inline-block;
            &:after {
                content: ':';
                display: inline-block;
            }
        `,
    },
    status: {
        css: css`
            margin-top: 3px;
            margin-bottom: 0.3125rem;
            margin-right: 0.3125rem;
            font-size: ${themeFontSizes.size18};
            display: inline-block;
            color: ${themeColors.colorCharcoalGrey};
            font-family: 'Roboto', sans-serif;
            line-height: 27px;
        `,
    },
};

const styles = statusStyles;

const OrderDetailsStatus:FC<Props> = ({ orderData }) => {
    const { value: order } = useContext(OrderStateContext);
    if ((!order || !order.statusDisplay)&&(!orderData ||!orderData.statusDisplay)) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="orderDetailsStatus">
                {translate("Status")}
            </Typography>
            <Typography {...styles.status} aria-labelledby="orderDetailsStatus" data-test-selector="orderDetailsStatus">
                {order?.statusDisplay??orderData?.statusDisplay}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderDetailsStatus),
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage",OrderStatusPageContext],
        group: "Order Details",
    },
};

export default widgetModule;
